import { axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/user";

class UserService {
  getAdminUserInfo = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/me`, {
        withCredentials: true,
      });
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching user info");
    }
  };

  getAvailablePackages = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/packages`, {
        withCredentials: true,
      });
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching available packages"
      );
    }
  };

  updateSubscriptionPackage = async (subscriptionPackage) => {
    try {
      const response = await axiosApiClient.put(
        `${BASE_URL}/subscription-package`,
        {
          subscriptionPackage,
        },
        {
          withCredentials: true,
        }
      );
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while updating subscription package"
      );
    }
  };

  changePassword = async ({ currentPassword, newPassword }) => {
    try {
      const response = await axiosApiClient.post(
        `${BASE_URL}/change-password`,
        {
          currentPassword,
          newPassword,
        }
      );

      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while changing password, status:" + err.code
      );
    }
  };
}

const userService = new UserService();

export default userService;
